export const CANADIAN_PROVINCES = [
    { value: 'AB', text: 'ALBERTA' },
    { value: 'BC', text: 'BRITISH COLUMBIA' },
    { value: 'MB', text: 'MANITOBA' },
    { value: 'NB', text: 'NEW BRUNSWICK' },
    { value: 'NL', text: 'NEWFOUNDLAND AND LABRADOR' },
    { value: 'NS', text: 'NOVA SCOTIA' },
    { value: 'ON', text: 'ONTARIO' },
    { value: 'PE', text: 'PRINCE EDWARD ISLAND' },
    { value: 'QC', text: 'QUEBEC' },
    { value: 'SK', text: 'SASKATCHEWAN' },
    { value: 'NT', text: 'NORTHWEST TERRITORIES' },
    { value: 'NU', text: 'NUNAVUT' },
    { value: 'YT', text: 'YUKON' },
];

export const US_STATES = [
    { value: 'AL', text: 'ALABAMA' },
    { value: 'AK', text: 'ALASKA' },
    { value: 'AZ', text: 'ARIZONA' },
    { value: 'AR', text: 'ARKANSAS' },
    { value: 'CA', text: 'CALIFORNIA' },
    { value: 'CO', text: 'COLORADO' },
    { value: 'CT', text: 'CONNECTICUT' },
    { value: 'DE', text: 'DELAWARE' },
    { value: 'FL', text: 'FLORIDA' },
    { value: 'GA', text: 'GEORGIA' },
    { value: 'HI', text: 'HAWAII' },
    { value: 'ID', text: 'IDAHO' },
    { value: 'IL', text: 'ILLINOIS' },
    { value: 'IN', text: 'INDIANA' },
    { value: 'IA', text: 'IOWA' },
    { value: 'KS', text: 'KANSAS' },
    { value: 'KY', text: 'KENTUCKY' },
    { value: 'LA', text: 'LOUISIANA' },
    { value: 'ME', text: 'MAINE' },
    { value: 'MD', text: 'MARYLAND' },
    { value: 'MA', text: 'MASSACHUSETTS' },
    { value: 'MI', text: 'MICHIGAN' },
    { value: 'MN', text: 'MINNESOTA' },
    { value: 'MS', text: 'MISSISSIPPI' },
    { value: 'MO', text: 'MISSOURI' },
    { value: 'MT', text: 'MONTANA' },
    { value: 'NE', text: 'NEBRASKA' },
    { value: 'NV', text: 'NEVADA' },
    { value: 'NH', text: 'NEW HAMPSHIRE' },
    { value: 'NJ', text: 'NEW JERSEY' },
    { value: 'NM', text: 'NEW MEXICO' },
    { value: 'NY', text: 'NEW YORK' },
    { value: 'NC', text: 'NORTH CAROLINA' },
    { value: 'ND', text: 'NORTH DAKOTA' },
    { value: 'OH', text: 'OHIO' },
    { value: 'OK', text: 'OKLAHOMA' },
    { value: 'OR', text: 'OREGON' },
    { value: 'PA', text: 'PENNSYLVANIA' },
    { value: 'RI', text: 'RHODE ISLAND' },
    { value: 'SC', text: 'SOUTH CAROLINA' },
    { value: 'SD', text: 'SOUTH DAKOTA' },
    { value: 'TN', text: 'TENNESSEE' },
    { value: 'TX', text: 'TEXAS' },
    { value: 'UT', text: 'UTAH' },
    { value: 'VT', text: 'VERMONT' },
    { value: 'VA', text: 'VIRGINIA' },
    { value: 'WA', text: 'WASHINGTON' },
    { value: 'WV', text: 'WEST VIRGINIA' },
    { value: 'WI', text: 'WISCONSIN' },
    { value: 'WY', text: 'WYOMING' },
    { value: 'DC', text: 'DISTRICT OF COLUMBIA' },
];

export const CANADIAN_PROVINCE_CODES = CANADIAN_PROVINCES.map(p => p.value);
export const US_STATE_CODES = US_STATES.map(s => s.value);
